import { HexaIcons, PaymentType } from '@/resources/enums'
import { ORDER_PAGE as dict } from '@/resources/dict'

type PaymentMethodIcon = { icon: HexaIcons }

export const isOnlinePayment = (paymentType?: PaymentType | string) => {
  return (
    paymentType === PaymentType.ONLINE_PAYMENT ||
    paymentType === PaymentType.PIX ||
    paymentType === PaymentType.NUPAY
  )
}

export const isOnlinePaymentCredit = (paymentType?: PaymentType | string) => {
  return paymentType === PaymentType.ONLINE_PAYMENT
}

export const getOnlinePaymentText = (paymentType: PaymentType) => {
  switch (paymentType) {
    case PaymentType.PIX:
      return dict.paymentType.pix
    case PaymentType.NUPAY:
      return dict.paymentType.nupay
    case PaymentType.ONLINE_PAYMENT:
    default:
      return dict.paymentType.onlinePayment
  }
}

export const getPaymentMethodIcon: (
  paymentMethod: PaymentType
) => PaymentMethodIcon = (paymentMethod: PaymentType) => {
  switch (paymentMethod) {
    case PaymentType.CASH:
      return { icon: HexaIcons.CASH }
    case PaymentType.CREDIT_CARD:
    case PaymentType.DEBIT_CARD:
    case PaymentType.ONLINE_PAYMENT:
      return { icon: HexaIcons.CREDIT_CARD }
    case PaymentType.PIX:
      return { icon: HexaIcons.PIX }
    case PaymentType.NUPAY:
      return { icon: HexaIcons.NUPAY }
    case PaymentType.NUPAY_CREDIT:
      return { icon: HexaIcons.NUPAY }
    case PaymentType.NUPAY_DEBIT:
      return { icon: HexaIcons.NUPAY }
  }
}
